import React, { useEffect, useState, useRef } from "react";
import { FaCheckCircle } from "react-icons/fa";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import { useCart } from "../contexts/CartContext";
import jsPDF from "jspdf";
import { trackOrder } from "../services/nonAuthRequets";
import { logoBase64Invoice } from "../utils/constants";
import BottomFooter from "../components/BottomFooter";
import ReturnSuccess from "../components/ReturnSuccess";
import { CartProvider } from "../contexts/CartContext";
const ReturnSuccessPage = () => {
  

  return (
    <CartProvider>
      <ColorInit color={"bigmall"} />
      <ScrollToTop smooth color="#ef253c" />
      <HeaderOne />
      <ReturnSuccess />
      <FooterOne />
      <BottomFooter />
    </CartProvider>
  );
};

export default ReturnSuccessPage;
